export interface ICoworking {
  company_name: string;
  business_name: string;
  tax_id: string;
  fiscal_address: string;
  city: string;
  country: string;
  province: string;
  latitude: any;
  longitude: any;
  business_group: string;
  description: string;
  web: string;
  phone: string;
  email: string;
}

export interface ICoworkingMedia {
  video_1: any;
  photo_1: any;
  photo_2: any;
  photo_3: any;
  photo_4: any;
  photo_5: any;
}

export class Coworking implements ICoworking {
  company_name: string;
  business_name: string;
  tax_id: string;
  fiscal_address: string;
  city: string;
  country: string;
  province: string;
  latitude: any;
  longitude: any;
  business_group: string;
  description: string;
  web: string;
  phone: string;
  email: string;
  constructor(coworking: ICoworking) {
    this.company_name = coworking.company_name;
    this.business_name = coworking.business_name;
    this.tax_id = coworking.tax_id;
    this.fiscal_address = coworking.fiscal_address;
    this.city = coworking.city;
    this.country = coworking.country;
    this.province = coworking.province;
    this.latitude = coworking.latitude;
    this.longitude = coworking.longitude;
    this.business_group = coworking.business_group;
    this.description = coworking.description;
    this.web = coworking.web;
    this.phone = coworking.phone;
    this.email = coworking.email;
  }
}
